export default __webpack_public_path__ + "static/media/cross.9518492d.svg";